export const TOKEN_KEY = "@dommus-Token";
export const ID_KEY = "@dommus-Id";
export const ID_MODULE = "@dommus-module";
export const ID_CLIENT = "@dommus-client-Id";
export const NAME_CLIENT = "@dommus-client";
export const NAME_USER = "@dommus-user";
export const EMAIL_USER = "@dommus-mail";
export const ACCESS_USER = "@dommus-access";
export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getId = () => localStorage.getItem(ID_KEY);
export const getModule = () => localStorage.getItem(ID_MODULE);
export const getClient = () => localStorage.getItem(ID_CLIENT);
export const getClientName = () => localStorage.getItem(NAME_CLIENT);
export const getUserName = () => localStorage.getItem(NAME_USER);
export const getUserEmail = () => localStorage.getItem(EMAIL_USER);
export const getAccessUser = () => localStorage.getItem(ACCESS_USER);
export const login = response => {
  const { valido, id_usuario, nome, email, token, recuperar } = response.data;
  if (valido) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(ID_KEY, id_usuario);
    localStorage.setItem(NAME_USER, nome);
    localStorage.setItem(EMAIL_USER, email);

    if(recuperar){
      localStorage.setItem(ACCESS_USER, true);
    }else{
      localStorage.setItem(ACCESS_USER, false);
    }

  } else {
    this.logout();
  }

};
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ID_KEY);
  localStorage.removeItem(ID_MODULE);
  localStorage.removeItem(ID_CLIENT);
  localStorage.removeItem(NAME_CLIENT);
  localStorage.removeItem(NAME_USER);
  localStorage.removeItem(EMAIL_USER);
  localStorage.removeItem(ACCESS_USER);
};